import axios from "axios";

// TODO: find a way to properly package the baseURL
const http = axios.create({
  baseURL: process.env.PREACT_APP_MANAGER_URL
});

export const authenticate = (apiKey, userData) =>
  http({
    url: "/api/authenticate",
    method: "POST",
    headers: {
      "X-API-KEY": apiKey
    },
    data: {...userData, internal_id: userData.internalId, avatar_url: userData.avatar_url}
  });

export const fetchOrganization = (apiKey, organization) =>
  http({
    url: `/api/organizations/${organization}`,
    method: "GET",
    headers: {
      "X-API-KEY": apiKey
    }
  });

const httpRealtime = axios.create({
  baseURL: process.env.PREACT_APP_REALTIME_URL
});

export const fetchRoomDetails = (roomId) => httpRealtime({
  url: "/api/rooms/" + roomId,
  method: "GET",
});

export const changeRoomDetails = (roomId, { restrictedUntil, messageDisplayPeriodDays }) => httpRealtime({
  url: "/api/update-room",
  method: "POST",
  data: {
    roomId,
    restrictedUntil,
    messageDisplayPeriodDays
  }
});

export const silenceUser = (organizationId, internalId, timeoutMinutes) => httpRealtime({
  url: "/api/silence-user",
  method: "POST",
  data: {
    organizationId,
    internalId,
    timeoutMinutes
  }
});

export const fetchMessages = (roomId, start, end) => httpRealtime({
  url: `/api/rooms/${roomId}/messages?start=${start}&end=${end}`,
  method: "GET",
});

export const removeMessageByModerator = (roomId, messageId) => httpRealtime({
  url: `/api/moderation-remove-message`,
  method: "POST",
  data: {
    roomId,
    messageId
  }
});

export const searchMessages = (roomId, query) => httpRealtime({
  url: `/api/search-messages?roomId=${roomId}&query=${encodeURIComponent(query)}`,
  method: "GET"
});

export const sendAttachment = ({roomId, contactInternalId, senderInternalId, organizationId, file}, {onUploadProgress}) => {
  const formData = new FormData();
  formData.append("roomId", roomId);
  formData.append("contactInternalId", contactInternalId);
  formData.append("senderInternalId", senderInternalId);
  formData.append("organizationId", organizationId);
  formData.append("file", file);

  return httpRealtime({
    url: `/api/send-attachment`,
    data: formData,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress
  });
}



// WEBPACK FOOTER //
// ./api/index.js